import React, { useEffect } from 'react';
import { Prompt } from 'react-router-dom';

const MESSAGE = 'Есть несохранённые изменения. Уйти со страницы без сохранения?';

/**
 * Предупреждает, если в форме есть несохранённые изменения, а пользователь
 * уходит со страницы: переход по меню, «Отмена», кнопка «Назад», закрытие вкладки.
 *
 * bypassRef — ref, который форма выставляет в true перед переходом сразу после
 * успешного сохранения: в этот момент состояние «сохранено» ещё не успело обновиться.
 */
const UnsavedChangesPrompt = ({ when, bypassRef }) => {
    useEffect(() => {
        if (!when) return undefined;
        const handler = (e) => {
            e.preventDefault();
            e.returnValue = MESSAGE;
            return MESSAGE;
        };
        window.addEventListener('beforeunload', handler);
        return () => window.removeEventListener('beforeunload', handler);
    }, [when]);

    return (
        <Prompt
            when={when}
            message={(location) => {
                if (bypassRef && bypassRef.current) return true;
                // Переходы внутри той же формы (например, /new?release=…) уходом не считаются.
                if (location.pathname === window.location.pathname) return true;
                return MESSAGE;
            }}
        />
    );
};

export default UnsavedChangesPrompt;
